import { render, staticRenderFns } from "./rankingNav.vue?vue&type=template&id=0e1bede6&scoped=true&"
import script from "./rankingNav.vue?vue&type=script&lang=js&"
export * from "./rankingNav.vue?vue&type=script&lang=js&"
import style0 from "./rankingNav.vue?vue&type=style&index=0&id=0e1bede6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1bede6",
  null
  
)

export default component.exports